// ~/plugins/pullToRefresh.client.ts

export default defineNuxtPlugin(() => {
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  const isStandalone =
    ('standalone' in navigator && (navigator as any).standalone === true) || // legacy iOS
    window.matchMedia('(display-mode: standalone)').matches;

  if (!isIOS || !isStandalone) {
    return;
  }

  const threshold = 100;
  let startY = 0;
  let isPulling = false;
  let triggered = false;

  const spinner = document.createElement('div');
  spinner.id = 'wad4-app-reload-spinner';
  spinner.className = 'wad4-app-reload-spinner';
  spinner.innerHTML = '<div class="wad4-app-reload-spinner-circle"/>';
  document.body.appendChild(spinner);

  const setSpinnerTop = (y: number) => {
    spinner.style.top = `${Math.min(y, threshold)}px`;
  }

  window.addEventListener('touchstart', (e) => {
    if (window.scrollY === 0 && e.touches[0]) {
      startY = e.touches[0].clientY;
      isPulling = true;
      triggered = false;
    }
  })

  window.addEventListener('touchmove', (e) => {
    if (!isPulling || !e.touches[0]) {
      return;
    }

    const currentY = e.touches[0].clientY;
    const distance = currentY - startY;

    if (distance > 0 && distance < threshold) {
      setSpinnerTop(distance + 50);
      spinner.classList.add('wad4-app-reload-spinner--active');
    }

    if (distance >= threshold && !triggered) {
      triggered = true;
      isPulling = false;
      setSpinnerTop(10);
      setTimeout(() => {
        location.reload();
      }, 100)
    }
  })

  window.addEventListener('touchend', () => {
    isPulling = false;
    triggered = false;
    setSpinnerTop(-50);
    spinner.classList.remove('active');
  })
})
